import React, { useEffect } from "react";
import clsx from "clsx";
import { Box, Table } from "@material-ui/core";

import { useSelectedTheme, useTranslate } from "../../../Hooks";

import { DeleteIcon } from "../../../assets/icons";

// Styles
import useStyles from "./styles";

const AddAdditionalTable = ({
  initValue,
  others,
  setNewValue,
  columnName = "email",
  setData,
  item,
  newValue,
  index,
  setIsAdding,
  isRequired = false,
}) => {
  const styles = useStyles();
  const {
    theme: { palette },
  } = useSelectedTheme();
  const { translate } = useTranslate("HeaderView");

  const handleDelete = (indexToDelete) => {
    setNewValue((prev) => {
      let updatedOthers = prev?.others || [];

      if (initValue === newValue?.phone && indexToDelete === 0) {
        // Deleting the main initValue
        updatedOthers = prev?.others || [];
        const updated = {
          ...prev,
          phone: "",
          others: updatedOthers,
        };

        // Check if no others left
        if (updated?.others?.length === 0) {
          setIsAdding(false);
        }

        return updated;
      } else {
        // Deleting from others array
        updatedOthers = (prev?.others || []).filter(
          (_, i) => i !== indexToDelete - 1
        );
        const updated = {
          ...prev,
          others: updatedOthers,
        };

        // Check if no others left
        if (updatedOthers?.length === 0) {
          setIsAdding(false);
        }

        return updated;
      }
    });
  };

  useEffect(() => {
    const value = {
      others: others,
    };

    if (columnName === "email") {
      setNewValue({
        ...value,
        email: newValue?.email,
        typeId: item.data.lookupItem,
      });

      setData(index, {
        ...value,
        email: newValue?.email,
        typeId: item.data.lookupItem,
      });
    }
    // if (columnName === "Phone number")
    else {
      setNewValue({
        ...value,
        phone: newValue?.phone,
        typeId: item?.data?.lookupItem,
      });

      setData(index, {
        ...value,
        phone: newValue?.phone,
        typeId: item?.data?.lookupItem,
      });
    }

    if (!initValue && !newValue?.others?.length) {
      setIsAdding(false);
    }
  }, [others]);

  return (
    <Table className={styles.containerTableReminder}>
      <thead>
        <tr className={styles.containerTableHeader}>
          <th
            className={clsx(
              styles.containerTitleHeader,
              styles.typeTitleReminderStyles
            )}
            style={{ width: "82%" }}
          >
            {translate(columnName)}
          </th>
          <th
            className={clsx(
              styles.containerTitleHeader,
              styles.typeTitleReminderStyles
            )}
            style={{ width: "18%" }}
          >
            {translate("Action")}
          </th>
        </tr>
      </thead>

      <tbody className={styles.containerTableBody}>
        {initValue && (
          <tr className={styles.containerTableRow}>
            <td className={clsx(styles.forValue)}>{initValue}</td>

            {/* Delete action */}
            {!isRequired && (
              <td className={styles.containerActionButton}>
                <Box className={styles.containerIconActionButton}>
                  <DeleteIcon
                    width="20"
                    height="20"
                    fill={palette.button.tertiaryGray_fg}
                    style={{ cursor: "pointer" }}
                    onClick={() => handleDelete(0)}
                  />
                </Box>
              </td>
            )}
          </tr>
        )}
        {others?.map((item, index) => (
          <tr key={index + 1} className={styles.containerTableRow}>
            <td className={clsx(styles.forValue)}>{item}</td>

            {/* Delete action */}
            <td className={styles.containerActionButton}>
              <Box className={styles.containerIconActionButton}>
                <DeleteIcon
                  width="20"
                  height="20"
                  fill={palette.button.tertiaryGray_fg}
                  style={{ cursor: "pointer" }}
                  onClick={() => handleDelete(index + 1)}
                />
              </Box>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default AddAdditionalTable;
